interface IconAirConditionProps {
  size?: number | string;
  color?: string;
  className?: string;
}
/**
 *
 * IconAirCondition
 */
const IconAirCondition = ({ size = 48, color = '#4ADDC2', className }: IconAirConditionProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_93_9697)">
      <path
        d="M35.34 26.3401H13.66V21.6001H35.34V26.3401ZM40.24 7.14014H8.76003C6.28003 7.14014 4.28003 9.14014 4.28003 11.6201V21.8401C4.28003 24.3201 6.28003 26.3201 8.76003 26.3201H9.66003V21.0401C9.66003 19.1201 11.22 17.5801 13.12 17.5801H35.86C37.78 17.5801 39.32 19.1401 39.32 21.0401V26.3201H40.22C42.7 26.3201 44.7 24.3201 44.7 21.8401V11.6201C44.7 9.14014 42.7 7.14014 40.22 7.14014H40.24ZM24.5 28.7201C23.4 28.7201 22.5 29.6201 22.5 30.7201V38.8601C22.5 39.9601 23.4 40.8601 24.5 40.8601C25.6 40.8601 26.5 39.9601 26.5 38.8601V30.7201C26.5 29.6201 25.6 28.7201 24.5 28.7201ZM15.7 28.7601C14.6 28.7601 13.7 29.6601 13.7 30.7601C13.7 34.1201 10.96 36.8601 7.60003 36.8601C6.50003 36.8601 5.60003 37.7601 5.60003 38.8601C5.60003 39.9601 6.50003 40.8601 7.60003 40.8601C13.16 40.8601 17.7 36.3401 17.7 30.7601C17.7 29.6601 16.8 28.7601 15.7 28.7601ZM41.38 36.8601C38.02 36.8601 35.28 34.1201 35.28 30.7601C35.28 29.6601 34.38 28.7601 33.28 28.7601C32.18 28.7601 31.28 29.6601 31.28 30.7601C31.28 36.3201 35.8 40.8601 41.38 40.8601C42.48 40.8601 43.38 39.9601 43.38 38.8601C43.38 37.7601 42.48 36.8601 41.38 36.8601Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_93_9697">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconAirCondition;
